import React, { useEffect, useState } from 'react';
import SDGsImpactField from './SDGsImpactField';
import usePlansFrameworks from '../../../b2b-plans/hooks/usePlansFrameworks';

const PlanSDGsImpactField = ({ planUUID, sdgsCount = 20, className = null }) => {
    const { genericFwsRelated } = usePlansFrameworks(planUUID, [{ frameworkSuite: 'generic', fwIds: [2] }]);
    const [sdgs2030, setSdgs2030] = useState(null);

    useEffect(() => {
        if (planUUID && genericFwsRelated && genericFwsRelated.length == 1 && genericFwsRelated[0].level1sDTOs.length > 0) {
            setSdgs2030(genericFwsRelated[0]);
        } else {
            setSdgs2030(null);
        }
    }, [genericFwsRelated]);

    return (
        <SDGsImpactField 
            sdgs2030={sdgs2030} 
            sdgsCount={sdgsCount} 
            className={className} 
        />
    );
};

export default PlanSDGsImpactField;